// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__ta4Bw","title":"Slider_title__HbXxM","subTitle":"Slider_subTitle__YLyVc","sliderContainer":"Slider_sliderContainer__bi58b"};